import * as pdfDownloadReducer from '../../redux/modules/pdfDownload';

const mapStateToProps = state => ({
  employeeName: state.auth.user.employeeName,
  canDownload: state.travelExpense.configuration.requestFormIncluded
});

const mapDispatchToProps = {
  ...pdfDownloadReducer
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/pdf-download/index.js